<template>
  <b-modal
    ref="modal"
    v-model="isShown"
    :title="title"
    modal-class="spso-modal"
    hide-header-close
    hide-footer
    centered
    size="lg"
    @hidden="hideModal"
  >
    <v-row class="my-3">
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.supplier') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.supplier ? partProperties.supplier.asdb : '' }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.supplier_name') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.supplier ? partProperties.supplier.name : '' }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.plant') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.plant }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.analyst') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.supplier ? partProperties.supplier.analyst : '' }}
        </div>
      </v-col>
    </v-row>

    <v-row class="mb-3">
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.part_number') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.part.number }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.part_name') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.part.name }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.uom') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.part.UOM }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.weight') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.part.weight }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.pack_qty') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.part.packQty }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.pack') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.part.pack }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.multiplicity') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.partsupplier ? partProperties.partsupplier.multiplicity : '' }}
        </div>
      </v-col>
    </v-row>

    <v-row class="mb-3">
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.startToUseDay') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.part.startToUseDay
            && $moment(partProperties.part.startToUseDay).format('L') }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.transitTime') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.supplier ? partProperties.supplier.transitTime : '' }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.frequencyOfSending') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.supplier ? partProperties.supplier.shippingFrequency : '' }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.lastAsn') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.partsupplier ? partProperties.partsupplier.lastAsn : '' }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.lastQty') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.partsupplier ? partProperties.partsupplier.lastQty : '' }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.lastDate') }}
        </div>
        <div class="part-details__value">
          {{ (partProperties.partsupplier || {}).lastDate
            && $moment(partProperties.partsupplier.lastDate).format('L') }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="py-1"
      >
        <div class="part-details__label">
          {{ $t('common.totalQty') }}
        </div>
        <div class="part-details__value">
          {{ partProperties.partsupplier ? partProperties.partsupplier.totalQty : '' }}
        </div>
      </v-col>
    </v-row>
  </b-modal>
</template>

<script>
export default {
  name: 'PartDetails',

  model: {
    prop: 'value',
  },

  props: {
    value: {
      type: Boolean,
      default: () => false,
    },

    partProperties: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isShown: false,
    };
  },

  computed: {
    title() {
      return `${this.$t('common.part_details')} ${this.partProperties.part.number}`;
    },
  },

  watch: {
    value(val) {
      this.isShown = val;
    },
  },

  methods: {
    hideModal() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.part-details__label {
  color: var(--topaz);
}

.part-details__value {
  font-weight: 500;
  color: var(--black);
  min-height: 24px;
}
</style>
